import { autoinject, PLATFORM, useView } from 'aurelia-framework';
import { MdcDialog } from '@aurelia-mdc-web/dialog';

export interface ITransactionCategoryDialogModel {
  categoryTypeId: number;
  selectedCategory?: number;
}

@autoinject
@useView(PLATFORM.moduleName('elements/dialogs/transactionCategoryDialog/transactionCategoryDialog.html'))
export class TransactionCategoryDialog {
  dialog: MdcDialog;
  model: ITransactionCategoryDialogModel;

  async activate(model: ITransactionCategoryDialogModel) {
    this.model = model;
  }
}
